export default class Invoice {
	constructor(inv) {
		inv = inv || {}

		this.id = inv.id;
		this.invoiceNumber = inv.invoiceNumber;
		this.invoiceDate = inv.invoiceDate;
		this.dueDate = inv.dueDate;
		this.recordedInvoice = inv.recordedInvoice;
		this.amountWithTax = inv.amountWithTax;
		this.pdf = inv.pdf;
		this.netToPay = inv.netToPay;
		this.pdfFilename = inv.pdfFilename;
		this.paymentStatus = inv.paymentStatus;
	}
}



// WEBPACK FOOTER //
// ./src/opencell/model/invoicing/Invoice.js